import { createContext, useContext } from "react";

export type WorkspaceNavigationGuard = (proceed: () => void, cancel?: () => void) => void;
export const WorkspaceNavigationContext = createContext<{
  requestNavigation: (proceed: () => void, cancel?: () => void) => void;
  registerGuard: (guard: WorkspaceNavigationGuard) => () => void;
}>({
  requestNavigation: (proceed) => proceed(),
  registerGuard: () => () => undefined,
});
export function useTeamWorkspaceNavigation() { return useContext(WorkspaceNavigationContext); }
